import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=0cc495ba&scoped=true&"
import script from "./Carousel.vue?vue&type=script&lang=js&"
export * from "./Carousel.vue?vue&type=script&lang=js&"
import style0 from "./Carousel.vue?vue&type=style&index=0&id=0cc495ba&scoped=true&lang=css&"
import style1 from "./Carousel.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc495ba",
  null
  
)

export default component.exports